import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-text",
  "use": "foquz-icon-question-text-usage",
  "viewBox": "0 0 20 17",
  "content": "<symbol viewBox=\"0 0 20 17\" fill=\"none\" id=\"foquz-icon-question-text\"><path d=\"M1 1h18M1 6h18M1 11h18M1 16h10\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol